import * as types from './constants';

// Get Performance Links Tags
export const getPerformanceTagsRequest = data => (
  { type: types.GET_PERFORMANCE_TAGS_REQUEST, payload: data }
);

export const getPerformanceTagsDone = data => (
  { type: types.GET_PERFORMANCE_TAGS_DONE, payload: data }
);

export const getPerformanceTagsFailed = errors => (
  { type: types.GET_PERFORMANCE_TAGS_FAILED, payload: errors }
);